import { isNumber } from 'lodash';
import React, { FC, useRef, useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { rentMDataStore } from 'src/store/housingfunds/rentm';
import { dateCalendarFormatType, currentFormatTime, dateFormat } from 'src/utils/dateSet';
import { getMemberInfo } from 'src/utils/common';
import {
  errorModalViewStore,
  loadingModalViewStore,
  confirmModalViewStore,
  contentModalDep2ViewStore,
} from 'src/store/modal';
import { fetchInsertHouseRentM, fetchUpdateHouseRentM } from 'src/fetch/stepC/houseRentM';
import { getResidentId, formatRRN, validateRRN } from 'src/utils/charSet';
import InputBox from 'src/components/atoms/input/DefInputBox';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import LabelSelect from 'src/components/atoms/selectbox/LabelSelect';
import DefLabel from 'src/components/atoms/label/LabelContnet';
import CheckBox from 'src/components/atoms/CheckBox';
import HelpButton from 'src/components/atoms/buttons/HelpButton';
import Description from 'src/components/molecules/table/Description/Donation';
import InputDateBox from 'src/components/atoms/input/InputDateBox';
import {
  settlementNtsDataStore,
  ntsFileDataStore,
  settlementDataStore,
} from 'src/store/settlementInfo';
import { addComma } from 'src/utils/common';

interface Props {
  data: any;
  type: string;
}
const GridAdd: FC<Props> = ({ data, type }) => {
  const userInfoData: any = getMemberInfo();
  const queryClient = useQueryClient();
  const errorModalState = errorModalViewStore((state: any) => state.set);
  const loadingState = loadingModalViewStore((state: any) => state.set);
  const setConfirmModalState = confirmModalViewStore((state: any) => state.set);
  const closeModalState = confirmModalViewStore((state: any) => state.close);
  const setContentModalState = contentModalDep2ViewStore((state: any) => state.set);

  const storeData = rentMDataStore((state: any) => state.result).data || [];
  const storeInitPayload = rentMDataStore((state: any) => state.initPayload);
  const storePayload = rentMDataStore((state: any) => state.payload);
  const storePayloadBind = rentMDataStore((state: any) => state.bindPayload);
  const bindStoreParam = rentMDataStore((state: any) => state.param);
  const bindStoreBindParam = rentMDataStore((state: any) => state.bindParam);

  // 정산결과
  const settlementBindParam = settlementDataStore((state: any) => state.bindParam);
  const settlementParam = settlementDataStore((state: any) => state.param);
  // 정산결과(NTS)
  const ntsInfoBindParam = settlementNtsDataStore((state: any) => state.bindParam);
  const ntsInfoParam = settlementNtsDataStore((state: any) => state.param);
  // NTS 업로드파일 데이터
  const ntsFileBindParam = ntsFileDataStore((state: any) => state.bindParam);
  const ntsFileParam = ntsFileDataStore((state: any) => state.param);

  useEffect(() => {
    if (type === 'insert') {
      console.log('INSERT');
      const dateStr = currentFormatTime('YYYYMMDD');
      storePayloadBind({ ...storeInitPayload, hs_start_date: dateStr, hs_end_date: dateStr });
    } else {
      const storeData = data;
      for (const key in storePayload) {
        if (storeData) storePayload[key] = storeData[key];
      }
      storePayloadBind({ ...storePayload });
    }
  }, []);

  const dataTypeSet = [
    { id: '', value: '선택' },
    {
      id: '1',
      value: '단독주택',
    },
    {
      id: '2',
      value: '다가구',
    },
    {
      id: '3',
      value: '다세대주택',
    },
    {
      id: '4',
      value: '다세대주택',
    },
    {
      id: '5',
      value: '아파트',
    },
    {
      id: '6',
      value: '오피스텔',
    },
    {
      id: '7',
      value: '고시원',
    },
    {
      id: '8',
      value: '기타',
    },
  ];
  const checkedDataType =
    storePayload.hs_type === ''
      ? dataTypeSet[0]
      : {
          id: storePayload.hs_type,
          value: dataTypeSet.find((item: any) => item.id === storePayload.hs_type)?.value,
        };

  const dataTypeSelect: any = {
    checked: checkedDataType,
    options: dataTypeSet,
  };

  const dataHouseSet = [
    { id: '', value: '선택' },
    {
      id: 'G0000',
      value: '일반',
    },
    {
      id: 'G0037',
      value: '공공임대주택 월세액',
    },
    {
      id: 'G0042',
      value: '신용카드 월세액',
    },
  ];
  const checkedDataHouseSet =
    storePayload.etc_type === ''
      ? dataHouseSet[0]
      : {
          id: storePayload.etc_type,
          value: dataHouseSet.find((item: any) => item.id === storePayload.etc_type)?.value,
        };

  const houseDataTypeSelect: any = {
    checked: checkedDataHouseSet,
    options: dataHouseSet,
  };

  const help = {
    content: `
      <div className="_hint_content">
        <div className="_item">ㆍ 정치자금기부금, 고향사랑기부금, 우리사주조합기부금은 본인 지출액만 공제가능합니다.</div>
        <div className="_item">ㆍ 『기부장려금 신청금액』은 기부자의 세액공제 대신 기부금 단체에 환급하기 위해 신청한 금액입니다.</div>
        <div className="_item">ㆍ 금액(국세청·기타)에는 『기부장려금 신청금액』과의 합산이 아닌 제외된 공제대상금액을 입력합니다.</div>
      </div>
      `,
    title: '공제 대상 항목',
  };

  const help_t2 = {
    content: `
      <div className="_hint_content">
        <div className="_item">* 사업자 등록번호(주민등록번호)는 '-'를 제외한 숫자만 입력해야 합니다.</div>
      </div>
      `,
    title: '사업자등록번호',
  };

  const confirmSelect = (item: any, field: string) => {
    storePayload[field] = item.id;
    storePayloadBind({ ...storePayload });
  };

  const confirmEvt = () => {
    storePayload.acct_year = userInfoData.acct_year;
    storePayload.co_cd = userInfoData.co_cd;
    storePayload.co_id = userInfoData.co_id;
    const param: any = storePayload;

    validationParam(storePayload);
    // validation
    const { status } = validationParam(storePayload);
    if (!status) {
      return false;
    }

    // 주민번호 체크
    if (storePayload.hs_res_id.indexOf('-') !== -1) {
      storePayload.hs_res_id = storePayload.hs_res_id.replaceAll('-', '');
    }

    // return false;
    fetchInsertHouseRentM(param, queryClient, errorModalState, loadingState, () => {
      const initialSeq = bindStoreParam.initialSeq || 0;
      bindStoreBindParam({ initialSeq: initialSeq + 1 });

      const initialSetSeq = settlementParam.initialSeq || 0;
      settlementBindParam({ initialSeq: initialSetSeq + 1 });
      const initialNtsSeq = ntsInfoParam.initialSeq || 0;
      ntsInfoBindParam({ initialSeq: initialNtsSeq + 1 });
      const initialFileSeq = ntsFileParam.initialSeq || 0;
      ntsFileBindParam({ initialSeq: initialFileSeq + 1 });

      setContentModalState({
        active: '',
      });
    });
  };

  // UPDATE
  const modifyEvt = () => {
    storePayload.acct_year = userInfoData.acct_year;
    storePayload.co_cd = userInfoData.co_cd;
    storePayload.co_id = userInfoData.co_id;

    // validation
    const { status } = validationParam(storePayload);
    if (!status) {
      return false;
    }

    // 주민번호 체크
    if (storePayload.hs_res_id.indexOf('-') !== -1) {
      storePayload.hs_res_id = storePayload.hs_res_id.replaceAll('-', '');
    }

    const param: any = storePayload;

    // return false;
    fetchUpdateHouseRentM(param, queryClient, errorModalState, loadingState, () => {
      const initialSeq = bindStoreParam.initialSeq || 0;
      bindStoreBindParam({ initialSeq: initialSeq + 1 });

      const initialSetSeq = settlementParam.initialSeq || 0;
      settlementBindParam({ initialSeq: initialSetSeq + 1 });
      const initialNtsSeq = ntsInfoParam.initialSeq || 0;
      ntsInfoBindParam({ initialSeq: initialNtsSeq + 1 });
      const initialFileSeq = ntsFileParam.initialSeq || 0;
      ntsFileBindParam({ initialSeq: initialFileSeq + 1 });

      setContentModalState({
        active: '',
      });
    });
  };

  const validationParam = (payloadSet: any) => {
    const resSet = { errText: { main: '', sub: '' }, status: true };
    //주민번호 체크
    // 800101-1234560
    // 801231-3234561
    if (!validateRRN(payloadSet.hs_res_id)) {
      resSet.errText.main = '잘못된 주민등록 번호입니다.';
      resSet.errText.sub = '내용을 확인해 주세요.';
      resSet.status = false;
    }

    // 공백체크
    // if (payloadSet.name.trim() === '') {
    //   if (familyArr.length > 0) {
    //     resSet.errText.main = '성명을 입력해 주세요.';
    //     resSet.errText.sub = '';
    //     resSet.status = false;
    //   }
    // }

    if (!resSet.status)
      errorModalState({
        data: { mainTitle: resSet.errText.main, subTitle: resSet.errText.sub },
        active: '_active',
      });

    return resSet;
  };

  const checkClickEvt = (e: React.MouseEvent, type: string) => {
    let useYN = 'Y';
    if (type === 'on') useYN = 'N';
    console.log('useYN:::', useYN);
    storePayloadBind({ ...storePayload, is_htx_pdf: useYN });
  };
  const checkQuestionClickEvt = (e: React.MouseEvent, type: string) => {
    let useYN = 'Y';
    if (type === 'on') useYN = 'N';
    storePayloadBind({ ...storePayload, question_status: useYN });
  };

  const inpStrChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    const chkValue = e.target?.value || '';
    storePayload[key] = chkValue;
    storePayloadBind({ ...storePayload });
  };
  const inpChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    let chkValue = e.target?.value || '';
    chkValue = chkValue.replaceAll(',', '');
    const chkNum = Number(chkValue);
    if (chkNum || chkNum === 0) {
      storePayload[key] = chkNum;
      // 연 납입액(근무기간중)과 월세 월 납입액은 둘 중 하나만 입력 가능
      if (key === 'year_amt' && chkNum > 0) {
        storePayload.amt = 0;
      } else if (key === 'amt' && chkNum > 0) {
        storePayload.year_amt = 0;
      }
      storePayloadBind({ ...storePayload });
    }
  };
  // Confiram 주민번호
  const inpResChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    let value = e.target?.value.replace(/[^0-9]/g, ''); // 숫자만 허용
    if (value.length > 6) {
      value = value.slice(0, 6) + '-' + value.slice(6, 13);
    }
    storePayload[key] = value;
    storePayloadBind({ ...storePayload });
  };

  const calendarStartRef = useRef<HTMLInputElement | null>(null);
  const calendarStartEvt = (date: string) => {
    const dateStr = dateFormat(date, 'YYYYMMDD');
    storePayload.hs_start_date = dateStr;
    storePayloadBind({ ...storePayload });
  };
  const calendarEndEvt = (date: string) => {
    const dateStr = dateFormat(date, 'YYYYMMDD');
    storePayload.hs_end_date = dateStr;
    storePayloadBind({ ...storePayload });
  };

  return (
    <div className="_add_credit_layout">
      {/* <div className="_desc_div">
        <div className="_main">총 급여의 25% : 10,000,000</div>
        <div className="_sub">신용카드등은 총급여의 25% 이상이어야 공제 가능합니다.</div>
      </div> */}
      <div className="_title_div">
        <div className="_title">공제 대상 항목</div>
        <div className="_help_div">
          <HelpButton content={help.content} title={help.title} styleDef={{ width: '660px' }} />
        </div>
      </div>
      <div className="_inp_div">
        <div className="_opt_div">
          <div className="_item" style={{ zIndex: 20, width: '450px' }}>
            <LabelSelect
              label="주택유형"
              select={dataTypeSelect}
              labelStyle={{ width: '200px' }}
              boxStyleDef={{ width: 'calc(100% - 200px)' }}
              confirmEvent={confirmSelect}
              field="hs_type"
            />
          </div>
          <div className="_item" style={{ zIndex: 15, width: '450px' }}>
            <LabelSelect
              label="자료코드"
              select={houseDataTypeSelect}
              labelStyle={{ width: '200px' }}
              boxStyleDef={{ width: 'calc(100% - 200px)' }}
              confirmEvent={confirmSelect}
              field="etc_type"
            />
          </div>
          <div className="_item" style={{ zIndex: 5, width: '450px' }}>
            <InputBox
              changeEvt={e => inpStrChangeEvt(e, 'hs_nm')}
              // inputRef={inpRef}
              label="임대인 성명"
              status={''}
              labelPosition="left"
              value={storePayload.hs_nm}
              placeholder="값을 입력하세요"
              labelStyleDef={{ width: '200px', color: '#333', fontSize: '14px' }}
              // styleDef={boxStyle}
              inpStyleDef={{ textAlign: 'right' }}
            />
          </div>
          <div className="_item" style={{ zIndex: 5, width: '450px' }}>
            <InputBox
              changeEvt={e => inpResChangeEvt(e, 'hs_res_id')}
              // inputRef={inpRef}
              label="주민등록 번호"
              status={''}
              labelPosition="left"
              value={storePayload.hs_res_id}
              placeholder="값을 입력하세요"
              labelStyleDef={{ width: '200px', color: '#333', fontSize: '14px' }}
              // styleDef={boxStyle}
              inpStyleDef={{ textAlign: 'right' }}
            />
          </div>
          <div className="_item" style={{ zIndex: 5, width: '450px' }}>
            <InputBox
              changeEvt={e => inpStrChangeEvt(e, 'hs_area')}
              // inputRef={inpRef}
              label="주택면적"
              status={''}
              labelPosition="left"
              value={storePayload.hs_area}
              placeholder="값을 입력하세요"
              labelStyleDef={{ width: '200px', color: '#333', fontSize: '14px' }}
              // styleDef={boxStyle}
              inpStyleDef={{ textAlign: 'right' }}
            />
          </div>
          <div className="_item" style={{ zIndex: 5, width: '450px' }}>
            <InputBox
              changeEvt={e => inpStrChangeEvt(e, 'hs_address')}
              // inputRef={inpRef}
              label="임대차 계약서상 주소지"
              status={''}
              labelPosition="left"
              value={storePayload.hs_address}
              placeholder="값을 입력하세요"
              labelStyleDef={{ width: '200px', color: '#333', fontSize: '14px' }}
              // styleDef={boxStyle}
              inpStyleDef={{ textAlign: 'right' }}
            />
          </div>
          <div className="_item" style={{ zIndex: 5, width: '450px' }}>
            <InputBox
              changeEvt={e => inpChangeEvt(e, 'year_amt')}
              // inputRef={inpRef}
              label="연 납입액(근무기간중)"
              status={Number(storePayload.amt) > 0 ? '_disable' : ''}
              labelPosition="left"
              value={addComma(storePayload.year_amt)}
              placeholder="값을 입력하세요"
              labelStyleDef={{ width: '200px', color: '#333', fontSize: '14px' }}
              // styleDef={boxStyle}
              inpStyleDef={{ textAlign: 'right' }}
            />
          </div>
          <div className="_item" style={{ zIndex: 5, width: '450px' }}>
            <InputBox
              changeEvt={e => inpChangeEvt(e, 'amt')}
              // inputRef={inpRef}
              label="월세 월 납입액"
              status={Number(storePayload.year_amt) > 0 ? '_disable' : ''}
              labelPosition="left"
              value={addComma(storePayload.amt)}
              placeholder="값을 입력하세요"
              labelStyleDef={{ width: '200px', color: '#333', fontSize: '14px' }}
              // styleDef={boxStyle}
              inpStyleDef={{ textAlign: 'right' }}
            />
          </div>
          <div className="_item" style={{ zIndex: 5, width: '450px' }}>
            <CheckBox
              label="국세청 자료 여부"
              selected={storePayload.is_htx_pdf === 'Y' ? 'on' : 'off'}
              btnClickEvt={checkClickEvt}
              labelStyleDef={{ color: '#333', fontWeight: '500', width: '200px' }}
            />
          </div>
          <div className="_item" style={{ zIndex: 5, width: '450px' }}>
            <CheckBox
              label="설문 상태"
              selected={storePayload.question_status === 'Y' ? 'on' : 'off'}
              btnClickEvt={checkQuestionClickEvt}
              labelStyleDef={{ color: '#333', fontWeight: '500', width: '200px' }}
            />
          </div>
          <div className="_item" style={{ zIndex: 6, width: '450px' }}>
            <InputDateBox
              inpRef={calendarStartRef}
              value={currentFormatTime('YYYY.MM.DD')}
              status=""
              direction="left"
              placeholder=""
              label="임대차 계약 시작일"
              labelPosition="left"
              labelStyleDef={{ width: '200px', color: '#333', fontSize: '14px' }}
              styleDef={{
                width: 'calc(100% - 200px)',
                fontSize: '14px',
                fontWeight: '500',
              }}
              clickCalendarEvt={calendarStartEvt}
            />
          </div>
          <div className="_item" style={{ zIndex: 5, width: '450px' }}>
            <InputDateBox
              inpRef={calendarStartRef}
              value={currentFormatTime('YYYY.MM.DD')}
              status=""
              direction="left"
              placeholder=""
              label="임대차 계약 종료일"
              labelPosition="left"
              labelStyleDef={{ width: '200px', color: '#333', fontSize: '14px' }}
              styleDef={{
                width: 'calc(100% - 200px)',
                fontSize: '14px',
                fontWeight: '500',
              }}
              clickCalendarEvt={calendarEndEvt}
            />
          </div>
        </div>
      </div>
      <div className="_description">
        <Description />
      </div>
      <div className="_btn_div">
        {type === 'insert' ? (
          <DefaultButton
            text="내역 추가"
            styleDef={{ width: '250px' }}
            clickEvent={e => confirmEvt()}
            icon=""
            type="type5"
          />
        ) : (
          <DefaultButton
            text="내역 변경"
            styleDef={{ width: '250px' }}
            clickEvent={e => modifyEvt()}
            icon=""
            type="type3"
          />
        )}
      </div>
    </div>
  );
};

export default GridAdd;
